export default __webpack_public_path__ + "e0238d0e9b144983775a20a7789b5484.png";